<template>
  <div class="document" style="height: 100%">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">
            <div>
              Quick Tips
            </div>
          </div>
        </template>
      </es-header>
    </div>
    <ul class="tips-container has-text-left">
      <li
        v-for="(tip, index) in tips"
        :key="index"
        class="tip"
      >
        <div class="tip-header" role="heading"
            v-if="tip.header!==undefined">
          {{ tip.header }}
        </div>
        <div
          v-for="(body, index) in tip.body"
          v-html="body"
          :key="index"
          class="tip-body"
        >
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import EsHeader from '@/components/EsHeader.vue';

export default {
  components: {
    EsHeader,
  },
  props: {
    tips: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="sass" scoped>
  .tips-container
    padding: 1rem
    font-size: 12px
  .tip
    margin-bottom: 1rem
    &:last-child
      margin-bottom: 0
  .tip-header
    font-weight: bold
    padding-bottom: 0.5rem
  .tip-body
    margin-bottom: 0.5rem
    &:last-child
      margin-bottom: 0
</style>
